import moment from 'moment'

import { EventModel } from '@/app/models/newDelegation/eventModel'
import { ActivityModel } from '@/modules/drivers/types/activities'

export const hasVehicle = (event: EventModel): boolean =>
  event.vehicleId != null || !!event.registrationNumber

// WPF parity (TripChartPresenter.TrySetVehicle): an event without a vehicle takes it
// from the first activity of its day that starts at or after the event.
export const withVehicleFromActivities = <T extends EventModel>(
  event: T,
  activities: ReadonlyArray<ActivityModel> | undefined,
): T => {
  if (!event.date || hasVehicle(event) || !activities?.length) return event

  const date = moment(event.date)
  if (!date.isValid()) return event

  const dayEnd = date.clone().startOf('day').add(1, 'day')

  const next = activities
    .filter(
      (a) =>
        moment(a.startTime).isSameOrAfter(date) &&
        moment(a.startTime).isBefore(dayEnd),
    )
    .sort((a, b) => moment(a.startTime).diff(moment(b.startTime)))[0]

  if (!next || next.vehicleId == null) return event

  return {
    ...event,
    vehicleId: next.vehicleId,
    registrationNumber: next.registrationNumber,
    vehicleType: next.vehicleType ?? event.vehicleType,
  }
}

// An edit resolves the vehicle only for an event that is new or has just been moved.
export const withVehicleOnEdit = <T extends EventModel>(
  event: T,
  previous: EventModel | undefined,
  activities: ReadonlyArray<ActivityModel> | undefined,
): T => {
  const moved =
    !previous || !moment(previous.date).isSame(moment(event.date), 'minute')
  return moved ? withVehicleFromActivities(event, activities) : event
}
